import React, { useEffect, useState } from "react";
import { Radio, Spin } from "antd";

import { googleAds } from "appConfig";

import MobileCategory from "../../MobileCategory";
import MobileFooterButtons from "../../MobileFooterButtons";
import history from "../../../../history";
import styles from "./subLevel2Mobile.scss";
import { NewAdsSection } from "../../NewAdsSection";
import { DiscountedAdsSection } from "../../DiscountedAdsSection";
import { LevelSeeAll } from "../../LevelSeeAll";
import GoogleAd from "../../../../components/GoogleAd";
import { checkEmptyArray, formatNumber } from "../../../../services";
import AgeVerification from "../../../../components/AgeVerificationModal";
import { connect } from "react-redux";
import { selectCurrentCategories, selectCurrentModuleName, selectModules } from "../../../App/selectors";
import { mapCategoryToEn } from "../../../../routes/LanguageMapper";
import { useAgeVerification } from "../../../../hooks/useAgeVerification";

interface SubLevel2MobileProps {
  category: string;
  categoryLv1Ids: any[];
  level: {
    checked: boolean;
    count: number;
    dataSource: string;
    hasChild: boolean | undefined;
    id: string;
    name: string;
  }[];
  levelCount: number;
  listKey: number;
  loading: boolean;
  module: string;
  onBoxClick: (ref: any) => void;
  onSearchClick: () => void;
  onSellectAll: () => void;
  topNumber: 5;
  moduleName: string;
  categories: any[];
  modules: any[];
}

const SubLevel2Mobile = (props: SubLevel2MobileProps) => {
  const {
    level,
    levelCount,
    category,
    categoryLv1Ids,
    categories,
    moduleName,
    modules,
    module,
    loading,
    onSearchClick,
    onBoxClick,
    onSellectAll
  } = props;

  const [displayData, setDisplayData] = useState([]);
  const [sourceData, setSourceData] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [value, setValue] = useState('all');

  // Use unified age verification hook
  const { ageVerificationModal, shouldShowModal, forbiddAds } = useAgeVerification({
    module,
    category,
    modules,
    categories
  });

  useEffect(() => {
    populateDisplayData();
  }, [level]);

  const populateDisplayData = () => {
    const { level, topNumber } = props;

    const sourceData = level;
    const displayData = sourceData
      .sort((l1, l2) => l2.count - l1.count)
      .slice(0, isExpanded ? sourceData.length : topNumber);

    setDisplayData(displayData);
    setSourceData(sourceData);
  };

  const handleSeeAllClick = () => {
    const displayData = sourceData.sort((l1, l2) => l2.count - l1.count);
    setIsExpanded(true);
    setDisplayData(displayData);
  };

  const handleChoosenValue = (e) => {
    const val = e.target.value;
    setValue(val);

    if (val) {
      if (val === "all") {
        onSellectAll();
      } else {
        const mappedRadio = level.find(l => l.id === val);
        onBoxClick(mappedRadio);
      }
    }
  };

  const [routeLinks, setRouteLinks] = useState([]);

  useEffect(() => {
    if (categories.length > 0) {
      const categoryName = categories.find(
        c => c.name === mapCategoryToEn(category, module)
      ).displayName;

      setRouteLinks([
        { title: moduleName, link: `/${module}` },
        { title: categoryName, link: `/${module}/${category}` },
      ]);
    }
  }, [moduleName, categories, module, category]);

  const renderContent = () => {
    const { listKey } = props;

    return (
      <React.Fragment key={listKey}>
        <div className={styles.title}>{"Odaberite model"}</div>
        <Radio.Group className={styles.levelContainer} onChange={handleChoosenValue} value={value}>
          <Radio
            value={'all'}
            className={styles.nameHolder}
            checked={!level.some(l => l.checked)}
          >
            <span className={styles.name}>{"Svi modeli"}</span>
            {levelCount ? <span className={styles.count}>{formatNumber(levelCount)}</span> : null}
          </Radio>

          {displayData.map(l => (
            <Radio
              key={`${l.id}_${l.checked}`}
              defaultChecked={l.checked}
              className={styles.nameHolder}
              checked={l.checked}
              value={l.id}
            >
              <span className={styles.name}>{l.name}</span>
              {l.count ? <span className={styles.count}>{formatNumber(l.count)}</span> : null}
            </Radio>
          ))}
        </Radio.Group>

        {sourceData.length === displayData.length ? null : (
          <LevelSeeAll onClick={handleSeeAllClick} />
        )}
      </React.Fragment>
    );
  };

  // if AgeVerification state is not calculated yet, we should not render
  if(ageVerificationModal === null && (!checkEmptyArray(categories) || !checkEmptyArray(modules))) {
    return null;
  }

  // Check if age verification is required
  if (shouldShowModal) {
    return <AgeVerification />;
  }

  return (
    <div className={styles.container}>
      {loading ? (
        <Spin
          className={styles.loading}
          tip={"Učitavam..."}
          size="large"
        />
      ) : (
        renderContent()
      )}
      <MobileFooterButtons
        onLeftClick={() => {
          history.push(`/${module}/${category}`);
        }}
        onRightClick={onSearchClick}
      />

      {!forbiddAds && (
        <GoogleAd
          className={styles.ads}
          config={{
            ...googleAds.subLevelMobile.box1,
            id: "googleAds.subLevelMobile.box1"
          }}
        />
      )}

      <DiscountedAdsSection
        isMobile
        module={module}
        category={category}
        className={styles.newAdsSection}
        categoryLv1Ids={categoryLv1Ids}
      />
      <NewAdsSection
        isMobile
        module={module}
        category={category}
        categoryLv1Ids={categoryLv1Ids}
        className={styles.newAdsSection}
        renderGoogleAds={index =>
          !forbiddAds && index % 6 === 5 ? (
            <GoogleAd
              className={styles.adsInList}
              config={{
                ...googleAds.subLevelMobile.box2,
                id: `googleAds.subLevelMobile.box2-${index}`
              }}
            />
          ) : null
        }
      />
    </div>
  );
};

SubLevel2Mobile.defaultProps = {
  levelCount: 0,
  topNumber: 5
};

export default connect(
  (state: any) => ({
    categories: selectCurrentCategories(state),
    moduleName: selectCurrentModuleName(state),
    modules: selectModules(state),
  }),
  {

  }
)((SubLevel2Mobile));



// WEBPACK FOOTER //
// ./src/containers/ModulePage/SubLevel2/SubLevel2Mobile/index.tsx